import { useContext } from 'react';

import { User } from 'common/types/user.type';
import { createStateContext, createDispatchContext, AdminProvider } from 'components/partials/AdminProvider';

const StateContext = createStateContext<User>();
const DispatchContext = createDispatchContext<User>();

export const useAdminState = () => useContext(StateContext);
export const useAdminDispatch = () => useContext(DispatchContext);

export const Provider: React.FC = ({ children }) => {
  return (
    <AdminProvider StateContext={StateContext} DispatchContext={DispatchContext}>
      {children}
    </AdminProvider>
  );
};
